import React from 'react'
import Style from '../productAttribute.module.css'

/** Shows which way the mapping runs and flips it. */
const DirectionSwitch = ({ leftTitle, rightTitle, isDisabled, onFlip }) => (
    <div className={Style.directionSwitch}>
        <span className={Style.directionSystem}>{leftTitle}</span>
        <button
            type="button"
            className={Style.directionFlip}
            title="Swap mapping direction"
            aria-label={`Swap mapping direction, currently ${leftTitle} to ${rightTitle}`}
            disabled={isDisabled}
            onClick={onFlip}
        >
            <i className="uil-exchange" aria-hidden="true" />
        </button>
        <span className={Style.directionSystem}>{rightTitle}</span>
    </div>
)

export default DirectionSwitch
